import { render } from "./InputText.vue?vue&type=template&id=0f3524e2"
import script from "./InputText.vue?vue&type=script&lang=js"
export * from "./InputText.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wamp\\www\\Proyectos\\LICEO\\Cursos\\descargaConstancia\\descargaconstancia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__